import type { TagProps } from '@zillow/constellation';
import { Accordion, Heading } from '@zillow/constellation-10';

type AccordionContentContainerProps = {
  content: React.ReactNode;
  header?: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  tag?: typeof TagProps | null | undefined;
  id?: string | null;
  eventId?: string;
  accordionIndex: number;
};
/*
 * NOTE: This component is to be used with `Accordion.Root` from `@zillow/constellation-10`
 */
const AccordionContentContainer = ({
  content,
  header = '',
  headingLevel = 5,
  tag = null,
  id = null,
  eventId,
  accordionIndex,
}: AccordionContentContainerProps) => {
  return (
    <Accordion.Item
      value={accordionIndex.toString()}
      id={id ?? undefined}
      data-eventid={eventId}
      data-accordion-index={accordionIndex}
    >
      <Accordion.Header>
        <Heading level={headingLevel}>{header}</Heading>
        {tag}
      </Accordion.Header>
      <Accordion.Panel>{content}</Accordion.Panel>
    </Accordion.Item>
  );
};

export default AccordionContentContainer;
